import React, { useEffect, useState } from 'react';
import { EnvelopeIcon, PhoneIcon, MapPinIcon, ChatBubbleLeftRightIcon, ClockIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { getApiUrl } from '../config/api';

const fallback = {
  contact: {
    email: 'thevastra.store1999@gmail.com',
    phone: '+91 80773 69863',
    phoneTel: '+918077369863',
    whatsappUrl: 'https://wa.me/918077369863',
    address: 'Opposite SBS Medical College, Balawala, Dehradun, Uttarakhand 248008',
    hours: 'Mon-Fri, 10am to 6pm IST',
    responseTime: 'Our support team typically responds within 24 hours on business days.',
    intro: 'For any queries or support, contact us:',
  },
  faqs: [
    {
      question: 'How can I track my order?',
      answer: 'Log in to your account and visit the "My Orders" section to track your order status.',
    },
    {
      question: 'How do I request a return or refund?',
      answer: 'Please email us at thevastra.store1999@gmail.com within 48 hours of delivery with your order details.',
    },
    {
      question: 'Can I contact support via WhatsApp?',
      answer: 'Yes! Click the WhatsApp link above to chat with us directly.',
    },
  ],
};

const Support = () => {
  const [contact, setContact] = useState(fallback.contact);
  const [faqs, setFaqs] = useState(fallback.faqs);

  useEffect(() => {
    fetch(getApiUrl('/api/store'))
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.contact) setContact({ ...fallback.contact, ...data.contact });
        if (Array.isArray(data?.faqs) && data.faqs.length) setFaqs(data.faqs);
      })
      .catch(() => undefined);
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-pink-50 to-indigo-50 py-12 px-2">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-500 mb-6 text-center drop-shadow">
          Customer Support
        </h1>
        <p className="mb-6 text-lg text-gray-700 text-center">{contact.intro}</p>
        <ul className="mb-8 space-y-4">
          <li className="flex items-center gap-3 text-gray-800">
            <EnvelopeIcon className="h-6 w-6 text-pink-500" />
            <span>
              Email:{' '}
              <a href={`mailto:${contact.email}`} className="text-indigo-600 underline font-medium">
                {contact.email}
              </a>
            </span>
          </li>
          <li className="flex items-center gap-3 text-gray-800">
            <PhoneIcon className="h-6 w-6 text-pink-500" />
            <span>
              Phone:{' '}
              <a href={`tel:${contact.phoneTel}`} className="text-indigo-600 underline font-medium">
                {contact.phone}
              </a>
            </span>
          </li>
          <li className="flex items-center gap-3 text-gray-800">
            <ChatBubbleLeftRightIcon className="h-6 w-6 text-pink-500" />
            <span>
              WhatsApp:{' '}
              <a href={contact.whatsappUrl} className="text-indigo-600 underline font-medium" target="_blank" rel="noopener noreferrer">
                Chat with us
              </a>
            </span>
          </li>
          <li className="flex items-center gap-3 text-gray-800">
            <MapPinIcon className="h-6 w-6 text-pink-500" />
            <span>{contact.address}</span>
          </li>
          <li className="flex items-center gap-3 text-gray-800">
            <ClockIcon className="h-6 w-6 text-pink-500" />
            <span>Support Hours: {contact.hours}</span>
          </li>
        </ul>
        <div className="bg-pink-50 border-l-4 border-pink-400 p-4 rounded text-pink-700 text-center font-semibold mb-8">
          {contact.responseTime}
        </div>
        <div className="mt-8">
          <div className="flex items-center mb-4">
            <QuestionMarkCircleIcon className="h-7 w-7 text-indigo-500 mr-2" />
            <h2 className="text-2xl font-bold text-indigo-700">Frequently Asked Questions</h2>
          </div>
          <ul className="space-y-4 text-gray-700">
            {faqs.map((item) => (
              <li key={item.question}>
                <span className="font-semibold text-pink-600">Q: {item.question}</span>
                <br />
                A: {item.answer}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Support;
